export const JW_PLAYER_BASE = "https://cdn.jwplayer.com";
export const JW_PLAYER_LIBRARY = "bkltBF6R";
export const FALLBACK_IMAGE = "/research/images/fallbackImage.png";
export const FDR_FALLBACK_IMAGE = "/research/images/research_primary_blue.svg";
export const PERSON_FALLBACK_IMAGE = "/research/images/personPlaceholder.svg";
